const initDashboardAnalytic = {
  totalMembers: 0,
  increaseMember: "0%",
  isTotalMembersLoading: false,
  totalOcrsClaimed: 0,
  totalAmount: "0",
  isTotalOcrsClaimedLoading: false,
  totalRewardsRedeemed: 0,
  totalPointUsed: "0",
  isTotalRewardsRedeemedLoading: false,
  tiersChart: [],
  tiersTotalMember: [],
  tiersBackgroundColorChart: [],
  totalExpPoint: 0,
  totalUltraPoint: 0,
  newMembersPerMonth: [],
  totalMembersPerMonth: [],
  tenantPortals: [],
  totalPortalMembers: [],
  totalMembersGrowthPerPortal: {},
  provinces: [],
  totalMembersByProvince: [],
  totalTierMemberByProvince: [],
  totalTierSilverByProvince: [],
  totalTierGoldByProvince: [],
  totalTierPlatinumByProvince: [],
  totalMembersRegistered: 0,
  totalMembersVerifiedNumber: 0,
  totalMembersNftClaimed: 0,
  totalMembersNftNotClaimed: 0,
  membershipLeaderboards: [],
  totalMembersRaffle: 0,
  increaseMemberRaffle: "0%",
  isTotalMembersRaffleLoading: false,
  totalOcrRaffleClaimed: 0,
  totalCities: 0,
  isTotalOcrRafflesClaimedLoading: false,
  totalOcrRaffleAmount: "0",
  totalIncreaseOcrRaffleAmount: "0",
  isTotalOcrRaffleAmountLoading: false,
  raffleCities: [],
  totalOcrRaffles: [],
  totalOcrRafflesAmount: [],
  totalRaffles: [],
  totalRaffleWinners: [],
  raffleMerchantsForOcrClaimed: [],
  totalOcrRafflesByMerchant: [],
  raffleMerchantsForOcrAmount: [],
  totalOcrRafflesAmountByMerchant: [],
  citiesFilter: [],
  totalOcrRafflesByUser: [],
};

export const dashboardAnalyticReducer = (
  state = initDashboardAnalytic,
  action: any
) => {
  if (action.type === "SET_TOTAL_MEMBER") {
    return {
      ...state,
      totalMembers: action.value,
    };
  }
  if (action.type === "SET_INCREASE_MEMBER") {
    return {
      ...state,
      increaseMember: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_LOADING") {
    return {
      ...state,
      isTotalMembersLoading: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_CLAIMED") {
    return {
      ...state,
      totalOcrsClaimed: action.value,
    };
  }
  if (action.type === "SET_TOTAL_AMOUNT") {
    return {
      ...state,
      totalAmount: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_CLAIMED_LOADING") {
    return {
      ...state,
      isTotalOcrsClaimedLoading: action.value,
    };
  }
  if (action.type === "SET_TOTAL_REWARD_REDEEMED") {
    return {
      ...state,
      totalRewardsRedeemed: action.value,
    };
  }
  if (action.type === "SET_TOTAL_POINT_USED") {
    return {
      ...state,
      totalPointUsed: action.value,
    };
  }
  if (action.type === "SET_TOTAL_REWARD_REDEEMED_LOADING") {
    return {
      ...state,
      isTotalRewardsRedeemedLoading: action.value,
    };
  }
  if (action.type === "SET_TIER_CHART") {
    return {
      ...state,
      tiersChart: action.value,
    };
  }
  if (action.type === "SET_TIER_TOTAL_MEMBER") {
    return {
      ...state,
      tiersTotalMember: action.value,
    };
  }
  if (action.type === "SET_TIER_BACKGROUND_CHART") {
    return {
      ...state,
      tiersBackgroundColorChart: action.value,
    };
  }
  if (action.type === "SET_TOTAL_EXP_POINT") {
    return {
      ...state,
      totalExpPoint: action.value,
    };
  }
  if (action.type === "SET_TOTAL_ULTRA_POINT") {
    return {
      ...state,
      totalUltraPoint: action.value,
    };
  }
  if (action.type === "SET_NEW_MEMBER_PER_MONTH") {
    return {
      ...state,
      newMembersPerMonth: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_PER_MONTH") {
    return {
      ...state,
      totalMembersPerMonth: action.value,
    };
  }
  if (action.type === "SET_TENANT_PORTAL") {
    return {
      ...state,
      tenantPortals: action.value,
    };
  }
  if (action.type === "SET_TOTAL_PORTAL_MEMBER") {
    return {
      ...state,
      totalPortalMembers: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_GROWTH_PER_PORTAL") {
    return {
      ...state,
      totalMembersGrowthPerPortal: action.value,
    };
  }
  if (action.type === "SET_PROVINCES") {
    return {
      ...state,
      provinces: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_BY_PROVINCE") {
    return {
      ...state,
      totalMembersByProvince: action.value,
    };
  }
  if (action.type === "SET_TOTAL_TIER_MEMBER_BY_PROVINCE") {
    return {
      ...state,
      totalTierMemberByProvince: action.value,
    };
  }
  if (action.type === "SET_TOTAL_TIER_SILVER_BY_PROVINCE") {
    return {
      ...state,
      totalTierSilverByProvince: action.value,
    };
  }
  if (action.type === "SET_TOTAL_TIER_GOLD_BY_PROVINCE") {
    return {
      ...state,
      totalTierGoldByProvince: action.value,
    };
  }
  if (action.type === "SET_TOTAL_TIER_PLATINUM_BY_PROVINCE") {
    return {
      ...state,
      totalTierPlatinumByProvince: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_REGISTERED") {
    return {
      ...state,
      totalMembersRegistered: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_VERIFIED_NUMBER") {
    return {
      ...state,
      totalMembersVerifiedNumber: action.value,
    };
  }
  if (action.type === "SET_TOTAL_NFT_CLAIMED") {
    return {
      ...state,
      totalMembersNftClaimed: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_NFT_NOT_CLAIMED") {
    return {
      ...state,
      totalMembersNftNotClaimed: action.value,
    };
  }
  if (action.type === "SET_MEMBERSHIP_LEADERBOARD") {
    return {
      ...state,
      membershipLeaderboards: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_RAFFLE") {
    return {
      ...state,
      totalMembersRaffle: action.value,
    };
  }
  if (action.type === "SET_INCREASE_MEMBER_RAFFLE") {
    return {
      ...state,
      increaseMemberRaffle: action.value,
    };
  }
  if (action.type === "SET_TOTAL_MEMBER_RAFFLE_LOADING") {
    return {
      ...state,
      isTotalMembersRaffleLoading: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE_CLAIMED") {
    return {
      ...state,
      totalOcrRaffleClaimed: action.value,
    };
  }
  if (action.type === "SET_TOTAL_CITY") {
    return {
      ...state,
      totalCities: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE_CLAIMED_LOADING") {
    return {
      ...state,
      isTotalOcrRafflesClaimedLoading: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE_AMOUNT") {
    return {
      ...state,
      totalOcrRaffleAmount: action.value,
    };
  }
  if (action.type === "SET_TOTAL_INCREASE_OCR_RAFFLE_AMOUNT") {
    return {
      ...state,
      totalIncreaseOcrRaffleAmount: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE_AMOUNT_LOADING") {
    return {
      ...state,
      isTotalOcrRaffleAmountLoading: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_CITY") {
    return {
      ...state,
      raffleCities: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE") {
    return {
      ...state,
      totalOcrRaffles: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLES_AMOUNT") {
    return {
      ...state,
      totalOcrRafflesAmount: action.value,
    };
  }
  if (action.type === "SET_TOTAL_RAFFLE") {
    return {
      ...state,
      totalRaffles: action.value,
    };
  }
  if (action.type === "SET_TOTAL_RAFFLE_WINNER") {
    return {
      ...state,
      totalRaffleWinners: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_MERCHANT_FOR_OCR_CLAIMED") {
    return {
      ...state,
      raffleMerchantsForOcrClaimed: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE_BY_MERCHANT") {
    return {
      ...state,
      totalOcrRafflesByMerchant: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_MERCHANT_FOR_OCR_AMOUNT") {
    return {
      ...state,
      raffleMerchantsForOcrAmount: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLES_AMOUNT_BY_MERCHANT") {
    return {
      ...state,
      totalOcrRafflesAmountByMerchant: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_CITY_FILTER_ANALYTIC") {
    return {
      ...state,
      citiesFilter: action.value,
    };
  }
  if (action.type === "SET_TOTAL_OCR_RAFFLE_BY_USER") {
    return {
      ...state,
      totalOcrRafflesByUser: action.value,
    };
  }
  return state;
};
